import { useState, type FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, ApiError } from "@/api/client";
import { useAuth } from "@/auth/AuthProvider";
import { PublicShell } from "@/public/PublicShell";

/** The invitation link: the new staff member sets a password and lands in the app signed in. */
export function InvitePage() {
  const { token = "" } = useParams();
  const { t } = useTranslation();
  const { loginWithToken } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (pw !== pw2) { setError(t("auth.pwMismatch")); return; }
    setBusy(true); setError(null);
    try {
      const r = await api<{ access_token: string }>("/auth/invite/accept", { method: "POST", body: JSON.stringify({ token, password: pw }) });
      await loginWithToken(r.access_token);
      nav("/app", { replace: true });
    } catch (err) { setError(err instanceof ApiError && err.status === 401 ? t("auth.inviteInvalid") : t("app.error")); }
    finally { setBusy(false); }
  };
  return (
    <PublicShell title={t("auth.inviteTitle")}>
      <form onSubmit={submit} className="space-y-3 rounded-2xl bg-surface p-5 shadow">
        <h1 className="text-lg font-semibold">{t("auth.inviteTitle")}</h1>
        <p className="text-sm text-muted">{t("auth.inviteText")}</p>
        <label className="block text-sm">{t("auth.newPassword")}<input className="mt-1 w-full rounded-lg border px-3 py-2" type="password" autoComplete="new-password" minLength={10} value={pw} onChange={(e) => setPw(e.target.value)} required /></label>
        <label className="block text-sm">{t("auth.repeatPassword")}<input className="mt-1 w-full rounded-lg border px-3 py-2" type="password" autoComplete="new-password" minLength={10} value={pw2} onChange={(e) => setPw2(e.target.value)} required /></label>
        <p className="text-xs text-muted">{t("users.passwordHint")}</p>
        {error && <p className="text-sm text-danger" role="alert">{error}</p>}
        <button disabled={busy} className="w-full rounded-lg bg-accent py-2 font-medium text-white disabled:opacity-50">{t("auth.setPassword")}</button>
      </form>
    </PublicShell>
  );
}
